import type { Site } from '@/types/models';

/**
 * Branch operations (0062). A site runs some of these; the server's
 * app.site_runs() decides what may be captured, this decides what is shown.
 */
export const OPERATIONS = [
  { key: 'concrete', label: 'Concrete', help: 'Concrete deliveries and targets.' },
  { key: 'brick', label: 'Brick Plant', help: 'Bricks, blocks and pavers: production, stock, dispatch, targets.' },
  { key: 'precast', label: 'Pre-cast', help: 'Fencing, palisade, kerbs: production, stock, dispatch, targets.' },
] as const;

export type Operation = (typeof OPERATIONS)[number]['key'];

/** The site's operations. A device copy from before 0062 has none: a branch
 *  was a concrete branch then. */
export function operationsOf(site: Pick<Site, 'kind' | 'operations'> | null | undefined): string[] {
  if (!site) return [];
  if (Array.isArray(site.operations)) return site.operations;
  return site.kind === 'branch' ? ['concrete'] : [];
}

export const siteRuns = (site: Pick<Site, 'kind' | 'operations'> | null | undefined, op: Operation): boolean =>
  operationsOf(site).includes(op);

export const operationLabel = (op: string): string => OPERATIONS.find((o) => o.key === op)?.label ?? op;
